module.exports = __webpack_public_path__ + "static/media/logo-livestock-blue.ff165919.svg";